<template>
  <div id="user-detail-form">
    <component
      :is="formTag"
      enctype="multipart/form-data"
      v-on:submit.prevent="submit"
    >
      <h3
        class="text-center"
      >
        <router-link
          :to="{
            name: 'user',
            params: {
              userId: userId
            }
          }"
        >
          {{ user.private_display_name }}
        </router-link>
      </h3>
      <div
        class="m-2 user-portrait-cont"
      >
        <div
          class="text-center user-portrait"
          v-if="portraitPreview"
        >
          <img :src="portraitPreview" />
        </div>
        <div
          class="text-center user-portrait"
          v-else
        >
          <img
            :src="userDetail.full_portrait_url"
          />
          <div
            class="text-right"
            v-if="!userDetail.default_portrait"
          >
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="user_user_detail_delete_portrait"
                name="user[user_detail_attributes][delete_portrait]"
                true-value="true"
                false-value="false"
                v-model="userDetail.delete_portrait"
              >
              <label
                class="form-check-label"
                for="user_user_detail_delete_portrait"
              >
                Delete Portrait?
              </label>
            </div>
          </div>
          <div
            class="text-center"
            v-else
          >
            <p>
              Default Portrait<br />
              <small>
                May differ depending on the site theme.
              </small>
            </p>
          </div>
        </div>
      </div>
      <div
        class="form-group"
      >
        <div class="input-group mb-3">
          <div class="custom-file">
            <div>
              <input
                type="file"
                name="user[user_detail_attributes][portrait]"
                class="custom-file-input"
                id="user_user_detail_portrait"
                @change="filesChange"
                accept="image/*"
              >
              <label
                class="custom-file-label"
                for="user_user_detail_portrait"
              >
                <span
                  v-if="!userDetail.default_portrait"
                >
                  Change
                </span>User Portrait
              </label>
            </div>
          </div>
        </div>
      </div>

      <div
        class="form-group"
      >
        <label
          for="user_user_detail_summary"
          class="control-label"
        >
          Author Summary/Strapline
        </label>

        <textarea
          name="user[user_detail_attributes][summary]"
          id="user_user_detail_summary"
          class="form-control"
          v-model="userDetail.summary"
        />
      </div>

      <div
        class="form-group"
      >
        <label
          for="user_user_detail_bio"
          class="control-label"
        >
          Author Profile (Links allowed)
        </label>

        <textarea
          name="user[user_detail_attributes][bio]"
          id="user_user_detail_bio"
          class="form-control"
          v-model="userDetail.bio"
        />
      </div>

      <div
        class="form-group"
      >
        <label
          for="user_user_detail_pronouns"
          class="control-label"
        >
          Pronouns
        </label>

        <input
          name="user[user_detail_attributes][pronouns]"
          id="user_user_detail_pronouns"
          class="form-control"
          v-model="userDetail.pronouns"
        />
      </div>

      <div
        class="form-group"
      >
        <label
          for="user_user_detail_social_urls_author_url"
          class="control-label"
        >
          Author Website
        </label>

        <div class="input-group mb-3">
          <input
            name="user[user_detail_attributes][social_urls][author_url]"
            type="url"
            id="user_user_detail_social_urls_author_url"
            class="form-control"
            placeholder="https://your-site.com"
            v-model="userDetail.social_urls.author_url"
          />
        </div>
      </div>

      <div
        class="form-group"
      >
        <label
          for="user_user_detail_social_urls_twitter"
          class="control-label"
        >
          Twitter
        </label>

        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">@</span>
          </div>

          <input
            name="user[user_detail_attributes][social_urls][twitter]"
            type="text"
            id="user_user_detail_social_urls_twitter"
            class="form-control"
            placeholder="Username"
            aria-label="Username" aria-describedby="basic-addon1"
            v-model="userDetail.social_urls.twitter"
          />
        </div>
      </div>

      <div
        class="form-group"
      >
        <label
          for="user_user_detail_social_urls_instagram"
          class="control-label"
        >
          Instagram
        </label>

        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">@</span>
          </div>

          <input
            name="user[user_detail_attributes][social_urls][instagram]"
            type="text"
            id="user_user_detail_social_urls_instagram"
            class="form-control"
            placeholder="Username"
            aria-label="Username" aria-describedby="basic-addon1"
            v-model="userDetail.social_urls.instagram"
          />
        </div>
      </div>

      <div
        class="form-group"
      >
        <label
          for="user_user_detail_social_urls_supplemental"
          class="control-label"
        >
          Supplemental Links
        </label>
      </div>

      <button
        type="submit"
        class="btn btn-primary btn-block"
        v-if="showSubmit"
      >
        Edit User Details
        <spinner
          size="small"
          v-if="loaders.settingUserDetails"
        />
      </button>
    </component>
  </div>
</template>
<script>
import { mapState } from 'vuex'

import Spinner from 'vue-simple-spinner'

export default {
  data () {
    return {
      portraitPreview: null
    }
  },

  computed: mapState({
    base: state => state.base,
    loaders: state => state.LoaderModule.loaders,
    user: state => state.UserModule.user,
    userDetail: state => state.UserDetailModule.user_detail,

    formTag () {
      return this.showSubmit ? 'form' : 'div'
    }
  }),

  components: {
    'spinner': Spinner
  },

  props: {
    showSubmit: {
      type: Boolean,
      default: false
    },

    userId: {
      type: [ Number, String ],
      default: undefined
    }
  },

  mounted () {
    this.get()
  },

  methods: {
    filesChange (ev) {
      this.portraitPreview = URL.createObjectURL(ev.target.files[0])

      this.$store.dispatch(
        'UserDetailModule/storeUserDetailPortrait', ev.target.files[0]
      ).catch(this.$root.processErrors)
    },

    get () {
      this.$store.dispatch(
        'UserModule/getUser', this.userId
      ).catch(this.$root.processErrors)

      this.$store.dispatch(
        'UserDetailModule/getUserDetails', this.userId
      ).catch(this.$root.processErrors)
    },

    submit (ev) {
      this.$store.dispatch(
        'UserDetailModule/setUserDetails', this.userId
      ).then(() => {
        this.portraitPreview = false
        this.$root.setFlashSuccess('User Updated')
      }).catch(this.$root.processErrors)
    }
  }
}
</script>

<style scoped>
.user-portrait img {
  min-height: 160px;
  min-width: 160px;
  max-height: 400px;
  max-width: 500px;
}
#user_user_detail_bio {
  height: 11rem;
}
</style>



// WEBPACK FOOTER //
// src/components/UserDetailForm.vue